import { DevelopmentalData } from "@/types/developmental";

export const age4Milestones: DevelopmentalData = {
  motor: [
    "Hops and stands on one foot",
    "Catches ball consistently",
    "Uses scissors",
    "Draws recognizable pictures",
    "Copies most letters"
  ],
  language: [
    "Speaks clearly in complex sentences",
    "Tells detailed stories",
    "Uses future tense",
    "Follows multi-step instructions",
    "Names letters and numbers"
  ],
  cognitive: [
    "Counts to 10 or higher",
    "Names colors and shapes",
    "Understands basic patterns",
    "Shows interest in reading",
    "Understands basic time concepts"
  ],
  independent: [
    "Dresses independently",
    "Uses bathroom independently",
    "Helps with household tasks",
    "Follows safety rules",
    "Organizes belongings"
  ],
  social: [
    "Plays cooperatively",
    "Negotiates solutions",
    "Shows leadership in play",
    "Understands others' feelings",
    "Forms friendships"
  ]
};